import { render } from "./govschememaster.vue?vue&type=template&id=11accfdb&scoped=true"
import script from "./govschememaster.vue?vue&type=script&lang=js"
export * from "./govschememaster.vue?vue&type=script&lang=js"

import "./govschememaster.vue?vue&type=style&index=0&id=11accfdb&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11accfdb"]])

export default __exports__